/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateLeadDtoGen,
  MrfiktivLeadControllerFindAllParamsGen,
  MrfiktivLeadPopulatedViewModelGen,
  MrfiktivLeadViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateLeadDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Lead<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags lead
   * @name LeadControllerCreate
   * @summary Create a lead
   * @request POST:/partner/{partnerId}/lead
   * @secure
   * @response `201` `MrfiktivLeadPopulatedViewModelGen` Created lead
   */
  leadControllerCreate = (partnerId: string, data: MrfiktivCreateLeadDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/lead`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead
   * @name LeadControllerFindAll
   * @summary Get all leads
   * @request GET:/partner/{partnerId}/lead
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivLeadViewModelGen)[] })`
   */
  leadControllerFindAll = (
    { partnerId, ...query }: MrfiktivLeadControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivLeadViewModelGen[] }, any>({
      path: `/partner/${partnerId}/lead`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead
   * @name LeadControllerGetOne
   * @summary Get a lead
   * @request GET:/partner/{partnerId}/lead/{id}
   * @secure
   * @response `200` `MrfiktivLeadPopulatedViewModelGen` Found lead
   */
  leadControllerGetOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/lead/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead
   * @name LeadControllerUpdate
   * @summary Update a lead
   * @request PATCH:/partner/{partnerId}/lead/{id}
   * @secure
   * @response `200` `MrfiktivLeadPopulatedViewModelGen` Updated lead
   */
  leadControllerUpdate = (partnerId: string, id: string, data: MrfiktivUpdateLeadDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/lead/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead
   * @name LeadControllerDelete
   * @summary Delete a lead
   * @request DELETE:/partner/{partnerId}/lead/{id}
   * @secure
   * @response `200` `MrfiktivLeadPopulatedViewModelGen` Deleted lead
   */
  leadControllerDelete = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/lead/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags lead
   * @name LeadControllerUpdateStatus
   * @summary Update lead status
   * @request PATCH:/partner/{partnerId}/lead/{id}/status/{status}
   * @secure
   * @response `200` `MrfiktivLeadPopulatedViewModelGen` Updated lead
   */
  leadControllerUpdateStatus = (partnerId: string, id: string, status: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivLeadPopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/lead/${id}/status/${status}`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params
    });
}
